<template>
  <div class="user-title">
    <li class="nav-item" style="color:rgb(40, 114, 198)!important;">
      <router-link class="nav-link" id="not-hover" to="" disabled>Χρήστης: {{user.vathmosmenu}} {{username}}</router-link>
    </li>
    <div id="txtME"  style="font-size:14px; margin-top:4px;">
      <small>{{ userTitle }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserTitle",
  computed: {
    role: function() {
      return this.$store.getters.userRole;
    },
    user: function() {
      return this.$store.getters.user;
    },
    username: function() {
      if (this.$store.getters.user.onoma) {
        return this.$store.getters.user.onoma + ' ' + this.$store.getters.user.epitheto
      }
      return null
    },
    userTitle: function () {
      switch (this.role) {
        case 'ROLE_MANAGER':
        case 'ROLE_SXHMATISMOS':
          return "(Διαχειριστής για την " + this.user.yphrMonada + ")"

        case 'ROLE_ADMIN':
        case 'ROLE_SUPERADMIN':
          return "(Διαχειριστής για την Διεύθυνση Επιστρατεύσεως - Εθνοφυλακής)"

        default:
          return ""
      }
    }
  }
}
</script>

<style scoped>

</style>